export const GET_FACILITIES_ME_REQUESTED = "GET_FACILITIES_ME_REQUESTED";
export const GET_FACILITIES_ME_SUCCEEDED = "GET_FACILITIES_ME_SUCCEEDED";
export const GET_FACILITIES_ME_FAILED = "GET_FACILITIES_ME_FAILED";
